import { http } from './http';
import {
  Bilan,
  CreateBilanPayload,
  PlanningResponse,
  Student,
  StudentDetail,
  TodayResponse,
} from '../types';

export const instructorApi = {
  async getToday(): Promise<TodayResponse> {
    const { data } = await http.get<TodayResponse>('/v1/instructor/me/today');
    return data;
  },
  async getPlanning(week?: string): Promise<PlanningResponse> {
    const { data } = await http.get<PlanningResponse>(
      '/v1/instructor/me/planning',
      { params: week ? { week } : undefined },
    );
    return data;
  },
  async getStudents(): Promise<Student[]> {
    const { data } = await http.get<Student[]>('/v1/instructor/me/students');
    return data;
  },
  async getStudent(id: string): Promise<StudentDetail> {
    const { data } = await http.get<StudentDetail>(
      `/v1/instructor/me/students/${id}`,
    );
    return data;
  },
  async createBilan(payload: CreateBilanPayload): Promise<Bilan> {
    const { data } = await http.post<Bilan>('/v1/instructor/me/bilans', payload);
    return data;
  },
};
